import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function LoginPage() {
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [err, setErr] = useState<string | null>(null);

  return (
    <div className="admin-shell">
      <div className="card" style={{ maxWidth: 520, margin: "40px auto" }}>
        <h1 style={{ marginTop: 0 }}>管理ログイン</h1>
        <p style={{ color: "var(--muted)", fontSize: 13 }}>
          パスワードは `.dev.vars`（本番は Wrangler Secret）で設定します。ログインに成功すると、サーバー側セッションが発行されます。
        </p>
        <input className="input" type="password" placeholder="パスワード" value={pw} onChange={(e) => setPw(e.target.value)} />
        {err && <p style={{ color: "#b00020" }}>{err}</p>}
        <div className="row" style={{ marginTop: 12 }}>
          <button
            className="btn"
            type="button"
            onClick={async () => {
              setErr(null);
              try {
                const res = await fetch("/api/auth/login", {
                  method: "POST",
                  credentials: "include",
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({ password: pw }),
                });
                const j = (await res.json().catch(() => ({}))) as { error?: string; message?: string };
                if (!res.ok) {
                  if (j.error === "invalid_password") {
                    setErr("パスワードが違います。`web/.dev.vars` の `ADMIN_PASSWORD=` の右と、一字一句同じにしてください。");
                    return;
                  }
                  if (j.error === "too_many_attempts") {
                    setErr(j.message || "試行回数が多いです。しばらく待ってから試してください。");
                    return;
                  }
                  if (j.error === "server_misconfigured") {
                    setErr(j.message || "サーバー設定（SESSION_SECRET）を確認してください。");
                    return;
                  }
                  setErr(j.message || "ログインできませんでした");
                  return;
                }
                nav("/admin/events/all");
              } catch {
                setErr("通信に失敗しました");
              }
            }}
          >
            ログイン
          </button>
          <button className="btn secondary" type="button" onClick={() => nav("/")}>
            表サイトへ
          </button>
        </div>
      </div>
    </div>
  );
}
